import { Navigate, Route, Routes } from "react-router-dom";

import { ReportsWrapperDiagrams } from "./reports.wrapper.diagrams";
import { ReportsWrapperTable } from "./reports.wrapper.table";

export const ReportsSwitchRoutes = (): JSX.Element => {
  return (
    <Routes>
      <Route path="table/*" element={<ReportsWrapperTable />} />
      <Route path="diagram/*" element={<ReportsWrapperDiagrams />} />
      <Route path="/*" element={<Navigate to="table" />} />
    </Routes>
  );
};
